import { useState } from 'react'
import { Icon } from 'components/ui/Icon'

type WidgetFileUploadPreviewProps = {
  onClickDelete: () => void
}

export const WidgetFileUploadPreview = ({ onClickDelete }: WidgetFileUploadPreviewProps) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={`
        tw-flex tw-flex-column tw-justify-center tw-items-center tw-rounded-md
        tw-h-14 tw-w-14 tw-relative
        ${isHovered ? 'tw-bg-gray-400' : 'tw-bg-gray-300'}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon icon={['fas', 'file']} size={'lg'} />
      {isHovered && (
        <div
          className="tw-absolute tw-cursor-pointer tw-top-0 tw-right-0 tw-flex tw-flex-column tw-justify-center tw-items-center tw-p-1"
          onClick={(e) => {
            e.stopPropagation()
            onClickDelete()
          }}
        >
          <Icon icon={['far', 'times']} size={'sm'} />
        </div>
      )}
    </div>
  )
}
